import gql from 'graphql-tag'

import useApi from '~/composables/useApi'

import { complementFrag } from '../blocks'
import { newsCategories } from '../utils'

export const SEARCH_COMPLEMENTS_QUERY = gql`
  query SEARCH_COMPLEMENTS($search: String, $limit: Int, $site: [String]) {
    complements: entries(
      section: "complements"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on complement_Entry {
        ${complementFrag}
        searchScore
      }
    }
  }
`

export async function searchComplements (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_COMPLEMENTS_QUERY, {
    search: term, limit, site
  }, {}))?.complements || []
}

export const SEARCH_KITCHENS_QUERY = gql`
  query SEARCH_KITCHENS($search: String, $limit: Int, $site: [String]) {
    kitchens: entries(
      section: "kitchens"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on kitchen_Entry {
        id
        slug
        title
        kitchenType {
          ... on kitchenType_Entry {
            id
            title
          }
        }
        searchScore
      }
    }
  }
`

export async function searchKitchens (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_KITCHENS_QUERY, {
    search: term, limit, site
  }, {}))?.kitchens || []
}

export const SEARCH_LIVINGS_QUERY = gql`
  query SEARCH_LIVINGS($search: String, $limit: Int, $site: [String]) {
    livings: entries(
      section: "livings"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on living_Entry {
        id
        slug
        title
        searchScore
      }
    }
  }
`

export async function searchLivings (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_LIVINGS_QUERY, {
    search: term, limit, site
  }, {}))?.livings || []
}

export const SEARCH_LIFE_STORIES_QUERY = gql`
  query SEARCH_LIFE_STORIES($search: String, $limit: Int, $site: [String]) {
    lifeStories: entries(
      section: "lifeStories"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on lifeStory_Entry {
        id
        slug
        title
        firstname
        city
        searchScore
      }
    }
  }
`

export async function searchLifeStories (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_LIFE_STORIES_QUERY, {
    search: term, limit, site
  }, {}))?.lifeStories || []
}

export const SEARCH_AWARDS_QUERY = gql`
  query SEARCH_AWARDS($search: String, $limit: Int, $site: [String]) {
    awards: entries(
      section: "awards"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on awards_Entry {
        id
        slug
        title
        abstract
        searchScore
      }
    }
  }
`

export async function searchAwards (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_AWARDS_QUERY, {
    search: term, limit, site
  }, {}))?.awards || []
}

export const SEARCH_INITIATIVES_QUERY = gql`
  query SEARCH_INITIATIVES($search: String, $limit: Int, $site: [String]) {
    initiatives: entries(
      section: "initiatives"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on initiatives_Entry {
        id
        slug
        title
        subtitle
        searchScore
      }
    }
  }
`

export async function searchInitiatives (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_INITIATIVES_QUERY, {
    search: term, limit, site
  }, {}))?.initiatives || []
}

export const SEARCH_MAGAZINE_QUERY = gql`
  query SEARCH_MAGAZINE($search: String, $limit: Int, $site: [String]) {
    magazine: entries(
      section: "magazine"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on magazine_Entry {
        id
        slug
        title
        category: magazineCategories {
          ... on magazineCategories_Category {
            id
            title
            slug
          }
        }
        searchScore
      }
    }
  }
`

export async function searchMagazine (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_MAGAZINE_QUERY, {
    search: term, limit, site
  }, {}))?.magazine || []
}

export const SEARCH_NEWS_QUERY = gql`
  query SEARCH_NEWS($search: String, $limit: Int, $site: [String]) {
    news: entries(
      section: "news"
      search: $search
      limit: $limit
      site: $site
      newsCategories: ":notempty:"
      orderBy: "score DESC"
    ) {
      ... on news_Entry {
        id
        slug
        title
        categories: newsCategories {
          ${newsCategories}
        }
        searchScore
      }
    }
  }
`

export async function searchNews (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_NEWS_QUERY, {
    search: term, limit, site
  }, {}))?.news || []
}

export const SEARCH_MAINTENANCE_QUERY = gql`
  query SEARCH_MAINTENANCE($search: String, $limit: Int, $site: [String]) {
    maintenance: entries(
      section: "maintenance"
      search: $search
      limit: $limit
      site: $site
      orderBy: "score DESC"
    ) {
      ... on maintenance_Entry {
        id
        slug
        title
        categories: maintenanceCategories {
          id
          title
          slug
        }
        searchScore
      }
    }
  }
`

export async function searchMaintenance (term, { limit = 5, site } = {}) {
  return (await useApi(SEARCH_MAINTENANCE_QUERY, {
    search: term, limit, site
  }, {}))?.maintenance || []
}
